import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { useAppContext } from "../../Contexts/AppContext";
import SidePanel from "./SidePanel";
import MySchedule from "./CourtSchedule";
import AllCases from "./AllCases";
import ApprovedCases from "./ApprovedCases";
import PendingCases from "./PendingCases";
import RejectedCases from "./RejectedCases";
import VcApplication from "./VCApplication/VcApplication";
import TrackCase from "./TrackCase";
import CaseDetails from "../CaseDetails/CaseDetails";
import { useCaseContext } from "../../Contexts/CaseContext";
import lawyeredLogo from "../Assets/TeleCourt.png";
import EditCaseDetails from "../EditCaseDetails/editCaseDetails";
import { useUserContext } from "../../Contexts/UserContext";
import ComplaintForm from "./ComplaintForm";
// import ChatScreen from "./ChatScreen";
import Ruling from "./Ruling";
import Judgement from "./Judgement";
import CourtRecords from "./CourtRecourds";
import RulingApplications from "./RulingApplications";
import JudgementApplications from "./JudgementApplication";
import UploadRulingJudgementRecordsDocument from "./UploadRulingJudgementRecords";
import CourtRecordsApplications from "./CourtRecordsApplication";
import CaseDocuments from "../CaseDetails/CaseDocument";
import UploadMoreDocument from "./uploadMoreDocuments";
import RulingDocuments from "../CaseDetails/RulingDocuments";
import JudgementDocuments from "../CaseDetails/JudgementDocuments";
import TranscriptionTable from "../transcriptions/transcription-table";
import UploadTranscription from "../transcriptions/upload-transcription";
import RepresentLitigant from "./RepresentLitigant";


const Dashboard: React.FC = () => {
	const { isLargeScreen } = useAppContext();
	const { caseData } = useCaseContext();
	const { userData } = useUserContext();
	const [isChatOpen, setIsChatOpen] = useState(false);

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const toggleChat = () => {
		setIsChatOpen(!isChatOpen);
	};

	return (
		<div>
			{userData.userRole === "JUDGE" ||
			userData.userRole === "COUNSEL" ||
			userData.userRole === "LEGAL_REGISTRAR" ||
			userData.userRole === "COURT_REGISTRAR" ||
			userData.userRole === "TRANSCRIBER" ? (
				<div
					className="main-div-dashboard w-full mt-20 md:p-10 py-10 px-3"
					style={{
						backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(${lawyeredLogo})`,
						backgroundSize: "40%",
						backgroundPosition: "center",
						backgroundRepeat: "no-repeat",
					}}>
					{isLargeScreen && (
						<div className="w-fit">
							<SidePanel />
						</div>
					)}
					<div className="w-[100%] lg:w-[80%] w-full p-4 ml-auto ">
						<Routes>
							<Route path="/" element={<AllCases />} />
							<Route
								path="/case-details/:id"
								element={<CaseDetails cases={caseData} />}
							/>
							<Route path="court-schedule" element={<MySchedule />} />
							<Route path="all-cases" element={<AllCases />} />
							<Route path="approved-cases" element={<ApprovedCases />} />
							<Route path="pending-cases" element={<PendingCases />} />
							<Route path="rejected-cases" element={<RejectedCases />} />
							<Route
								path="virtual-court-application"
								element={<VcApplication />}
							/>
							<Route
								path="apply-for-ruling/:id?"
								element={<Ruling />}
							/>
							<Route
								path="/apply-for-judgement/:id?"
								element={<Judgement />}
							/>
							<Route
								path="/case-document/:id?"
								element={<CaseDocuments cases={caseData}/>}
							/>
							<Route
								path="/apply-for-records/:id?"
								element={<CourtRecords />}
							/>
							<Route
								path="/ruling-application/"
								element={<RulingApplications />}
							/>
							<Route
								path="/judgement-applications/"
								element={<JudgementApplications />}
							/>
							<Route
								path="/court-records-applications/"
								element={<CourtRecordsApplications />}
							/>
							<Route
								path="/upload-ruling/:id/:applicationsType/:applicationsId"
								element={<UploadRulingJudgementRecordsDocument />}
							/>
							<Route
								path="/edit-case-details/:id"
								element={<EditCaseDetails cases={caseData} />}
							/>
							<Route
								path="/upload-more-document/:id"
								element={<UploadMoreDocument />}
							/>
							<Route
								path="/ruling-document/:id"
								element={<RulingDocuments cases={caseData} />}
							/>
							<Route
								path="/judgement-document/:id"
								element={<JudgementDocuments cases={caseData} />}
							/>
							<Route
								path="/view-transcription/:id"
								element={<TranscriptionTable cases={caseData} />}
							/>
							<Route path="/upload-transcription/:id" element={<UploadTranscription />} />
							<Route
								path="represent-litigant"
								element={<RepresentLitigant />}
							/>
							<Route path="track-case" element={<TrackCase />} />
							<Route path="make-a-complaint" element={<ComplaintForm />} />
						</Routes>
					</div>
				</div>
			) : (
				<div
					className="main-div-dashboard w-full mt-20 md:p-10 py-10 px-3"
					style={{
						backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(${lawyeredLogo})`,
						backgroundSize: "40%",
						backgroundPosition: "center",
						backgroundRepeat: "no-repeat",
					}}>
				</div>
			)}
			{/* Chat Widget Button */}
			{/* <button
				onClick={toggleChat}
				style={{
					position: "absolute",
					bottom: "20px",
					right: "20px",
					backgroundColor: "#9B111E",
					color: "#FFF",
					borderRadius: "50%",
					width: "60px",
					height: "60px",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					fontSize: "24px",
					cursor: "pointer",
					outline: "none",
					border: "none",
					boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
				}}>
				💬
			</button> */}

			{/* Conditionally render ChatScreen */}
			{/* {isChatOpen && <ChatScreen toggleChat={toggleChat} />} */}
		</div>
	);
};

export default Dashboard;
